// CSR-1305 / CSR-1881 — the Sales Agent dropdown must offer every agent
// relevant to an account, not just the current Flint producer roster. The
// roster is merged with historical names (former/terminated producers) so
// they stay selectable, while the field stays selection-only. Lives in
// `shared/` so both the server route (`GET /api/sales-agents`) and the
// client dropdown reuse one implementation.

/**
 * Merges any number of name lists into a single deduped, alphabetically
 * sorted list. Trims each name, drops empty/whitespace-only entries, and
 * dedupes case-insensitively keeping the first-seen spelling.
 */
export function mergeSalesAgentNames(...lists: string[][]): string[] {
  const byKey = new Map<string, string>();
  for (const list of lists) {
    for (const raw of list) {
      const name = raw.trim();
      if (name === "") continue;
      const key = name.toLowerCase();
      if (!byKey.has(key)) byKey.set(key, name);
    }
  }
  return Array.from(byKey.values()).sort((a, b) =>
    a.localeCompare(b, "en", { sensitivity: "base" }),
  );
}
